var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atomic-layout-section',{attrs:{"section":"results"}},[_c('atomic-smart-snippet'),_vm._v(" "),_c('atomic-smart-snippet-suggestions'),_vm._v(" "),_c('atomic-result-list',{attrs:{"density":"compact","image-size":"none","display":"grid"}},[_c('atomic-result-template',{domProps:{"innerHTML":_vm._s(_vm.hcxfPublicationResultTemplate)}})],1),_vm._v(" "),_c('atomic-query-error'),_vm._v(" "),_c('atomic-no-results')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3579211f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/hcxf/hcxf-publication-search-results.vue
// module id = 558
// module chunks = 0 1